import React from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import __ from "lodash";
import { CONFIG, CONFIG_UTIL } from "../../../../config";
import accountManagement from "../../../../apis/accountManagement";
import utilManagement from "../../../../apis/utilManagement";
import { ArrowBackIosOutlined } from "@material-ui/icons";

import DropdownProvinsi from "../masterDropDown/DropdownProvinsi";
import DropdownPtn from "../masterDropDown/DropdownPtn";
import DropdownProdi from "../masterDropDown/DropdownProdi";
import DropdownTingkatanPrestasi from "../masterDropDown/DropdownTingkatanPrestasi";
import DropdownSpesifikasiPrestasi from "../masterDropDown/DropdownSpesifikasiPrestasi";
import { data } from "jquery";
import { Card, RadioGroup, FormControlLabel, Radio, CardHeader } from "@material-ui/core";
import { Row, Col, Form, Alert, Modal, Button } from "react-bootstrap";

class FormMgtNilai extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            resMessage: null,
            dataSiswa: {},
            mapelSnmptn: [],
            nilaiRaport: [],
            provinsi: [],
            ptn1: [],
            ptn2: [],
            prodi1: [],
            prodi2: [],
            dataSemester: [],
            detailSemester: [],
            dataNilai: [],
            pilProdiSiswa: [],
            tingkatanPrestasi: [],
            spesifikasiPrestasi: [],
            spesifikasiPrestasiFilter: [],
            prestasiSiswa: [],
            idProvinsi1: null,
            idProvinsi2: null,
            idPtn1: null,
            idPtn2: null,
            idProdi1: null,
            idProdi2: null,
            kuota1: null,
            kuota2: null,
            idPrestasiSiswa: null,
            tingkatan: null,
            idSpesifikasi: null,
            spesifikasi: null,
            keterangan: null,
            regSiswa: null,
            inputSemester: [],
            kodeTahunAjaran: null,
            idKelas: null,
        };
    }
    componentDidMount() {
        document.title = "MGT Nilai SNMPTN";
        this.setState({
            dataSiswa: this.props.dataSiswa,
            kodeTahunAjaran: this.props.tahunAjaran,
            idKelas: this.props.idKelas,
        });
        console.clear();
        console.groupCollapsed("FORM NILAI SNMPTN IN");
        console.info("State", this.state);
        console.info("Props", this.props);
        console.groupEnd();
        this.fetchDetailSiswaSnmptn();
        this.getProvince();
    }

    handleBack() {
        this.props.handleBack();
    }

    handleOffFeching() {
        this.props.handleOffFeching();
    }

    handleOnFeching() {
        this.props.handleOnFeching();
    }

    fetchDetailSiswaSnmptn = async () => {
        // console.clear();

        if (this.props.dataSiswa.regSiswa == "0") {
            this.setState({ regSiswa: "sekolah" });
        } else {
            this.setState({ regSiswa: "mandiri" });
        }

        const dataForm = await utilManagement.get(CONFIG_UTIL.SNBP_GET_NILAI + this.props.dataSiswa.idSiswa + "&kodeTahunAjaran=" + this.props.tahunAjaran).catch(function (error) {});

        if (dataForm && dataForm.data.nilai !== null) {
            if (dataForm.data.status === CONFIG_UTIL.SUCCESS_ERROR_CODE) {
                console.log("fetchDetailSiswaSnmptn", dataForm);
                this.setState({
                    dataSemester: dataForm.data.nilai,
                    // nilaiRaport: dataForm.data.data.nilaiRaport,
                    // mapelSnmptn: dataForm.data.data.mapelSnmptn,
                    // provinsi: dataForm.data.data.provinsi,
                    // detailSemester: dataForm.data.data.detailSemester,
                    // tingkatanPrestasi: dataForm.data.data.tingkatanPrestasi,
                    // spesifikasiPrestasi: dataForm.data.data.spesifikasiPrestasi,
                    // pilProdiSiswa: dataForm.data.data.pilProdiSiswa,
                    // prestasiSiswa: dataForm.data.data.prestasiSiswa,
                    isFetching: false,
                });
            }

            // isi form rapot, jika edit
            dataForm.data.nilai.map((item, j) => {
                item.mapel.map((val, i) => {
                    this.setState({ ["#_" + val.idMapel + "_" + val.semester]: val.nilai });
                });
            });

            // isi prodi siswa, jika edit
            if (!__.isEmpty(dataForm.data.pilihanProdi)) {
                dataForm.data.pilihanProdi.map((val, j) => {
                    this.fetchPtnByPilihanSiswa(val.idProvinsi, val.idPtn, val.idProdi, j + 1);
                    this.fetchProdiByPilihanSiswa(val.idProvinsi, val.idPtn, val.idProdi, j + 1);
                    this.setState({
                        ["idProvinsi" + (j + 1)]: val.idProvinsi,
                        ["kuota" + (j + 1)]: val.kuota,
                    });
                });
            } else {
                this.handleOffFeching();
            }
        } else {
            this.handleOffFeching();
            this.setState({
                isFetching: false,
            });
        }
    };

    getProvince = async () => {
        const dataForm = await accountManagement
            .post(CONFIG.SNMPTN_FETCH_FORM_NILAI, {
                ["idKelas"]: this.props.idKelas,
                ["idSiswa"]: this.props.dataSiswa.idSiswa,
                ["semester"]: this.props.dataSiswa.semester,
            })
            .catch(function (error) {});
        console.log("dataForm", dataForm);

        if (dataForm && dataForm.data.data !== false) {
            if (dataForm.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    provinsi: dataForm.data.data.provinsi,
                    tingkatanPrestasi: dataForm.data.data.tingkatanPrestasi,
                    spesifikasiPrestasi: dataForm.data.data.spesifikasiPrestasi,
                    pilProdiSiswa: dataForm.data.data.pilProdiSiswa,
                    prestasiSiswa: dataForm.data.data.prestasiSiswa,
                    isFetching: false,
                });
            }

            // isi form prestasi siswa, jika edit
            dataForm.data.data.prestasiSiswa.map((valX, j) => {
                const arr = [];
                this.state.spesifikasiPrestasi.map((val, j) => {
                    if (valX.tingkatan == val.tingkatan) {
                        const data = {};
                        console.log("prestasi", val.idPrestasi);
                        data["idPrestasi"] = val.idPrestasi;
                        data["namaPrestasi"] = val.namaPrestasi;
                        arr.push(data);
                    }
                });

                this.setState({
                    spesifikasiPrestasiFilter: arr,
                    tingkatan: valX.tingkatan,
                    spesifikasi: valX.idSpesifikasiPrestasiSiswa,
                    keterangan: valX.keterangan,
                    idSpesifikasi: valX.idSpesifikasiPrestasi,
                });
            });
        } else {
            this.setState({
                isFetching: false,
            });
        }
    };

    handleOnchangeProvinsi = async (e) => {
        console.clear();
        const nameOption = e.target.name;
        const idProvinsi = e.target.value;
        console.log(e.target.name);
        this.setState({
            [e.target.name]: idProvinsi,
        });
        //   }

        const resPtn = await accountManagement.get(CONFIG.SNMPTN_FETCH_PTN + idProvinsi).catch(function (error) {
            console.error("getDetailJadwalVidConf Error", error);
        });

        if (resPtn) {
            if (resPtn.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                console.info("handleSubmit", resPtn);
            }

            if (nameOption == "idProvinsi1") {
                this.setState({
                    ptn1: resPtn.data.data.ptn,
                });
            } else {
                this.setState({
                    ptn2: resPtn.data.data.ptn,
                });
            }
        }
        console.info("PTN", resPtn.data.data.ptn);
    };

    handleOnchangePtn = async (e) => {
        console.clear();
        const nameOption = e.target.name;
        const idPtn = e.target.value;
        console.log(e.target.name);
        this.setState({
            [e.target.name]: idPtn,
        });
        //   });

        const resProdi = await accountManagement.get(CONFIG.SNMPTN_FETCH_PRODI + idPtn).catch(function (error) {
            console.error("getDetailJadwalVidConf Error", error);
        });

        if (resProdi) {
            if (resProdi.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                if (nameOption == "idPtn1") {
                    this.setState({
                        prodi1: resProdi.data.data.prodi,
                        idProdi1: "",
                    });
                } else {
                    this.setState({
                        prodi2: resProdi.data.data.prodi,
                        idProdi2: "",
                    });
                }
            }
        }
    };

    handleOnChangeProdi = async (e) => {
        console.clear();
        const nameOption = e.target.name;
        const idKodeProdi = e.target.value;
        console.log(e.target.name);
        this.setState({
            [e.target.name]: idKodeProdi,
        });
    };

    handleOnchangePrestasi = async (e) => {
        console.clear();
        const nameOption = e.target.name;
        const value = e.target.value;

        console.info("nama", nameOption);
        console.info("val", value);

        if (nameOption == "idSpesifikasi" || nameOption == "keterangan") {
            this.setState({ [nameOption]: value });
        } else {
            const arr = [];
            this.state.spesifikasiPrestasi.map((val, j) => {
                if (value == val.tingkatan) {
                    const data = {};
                    data["idPrestasi"] = val.idPrestasi;
                    data["namaPrestasi"] = val.namaPrestasi;
                    arr.push(data);
                }
            });
            this.setState({
                [nameOption]: value,
                spesifikasiPrestasiFilter: arr,
                idSpesifikasi: "",
            });
        }
    };

    handleOnChangeRegSiswa = async (e) => {
        console.clear();
        const nameOption = e.target.name;
        const value = e.target.value;

        console.info("nama", nameOption);
        console.info("val", value);

        this.setState({ [nameOption]: value });
    };

    // ISI DROPDOWN PILIHAN NEK SISWA WES MILIH PTN GAAN......................
    fetchPtnByPilihanSiswa = async (idProv, idPtn, idProdi, pilKe) => {
        const resPtn = await accountManagement.get(CONFIG.SNMPTN_FETCH_PTN + idProv).catch(function (error) {
            console.error("getDetailJadwalVidConf Error", error);
        });

        // isi PTN e sekk........................
        if (resPtn) {
            if (resPtn.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                console.info("handleSubmit", resPtn);
            }
            this.setState({
                ["ptn" + pilKe]: resPtn.data.data.ptn,
                ["idPtn" + pilKe]: idPtn,
            });
        }
    };

    // ISI DROPDOWN PILIHAN NEK SISWA WES MILIH PRODI GAAN......................
    fetchProdiByPilihanSiswa = async (idProv, idPtn, idProdi, pilKe) => {
        const resPtn = await accountManagement.get(CONFIG.SNMPTN_FETCH_PTN + idProv).catch(function (error) {
            console.error("getDetailJadwalVidConf Error", error);
        });

        const resProdi = await accountManagement.get(CONFIG.SNMPTN_FETCH_PRODI + idPtn).catch(function (error) {
            console.error("getDetailJadwalVidConf Error", error);
        });

        if (resProdi) {
            if (resProdi.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                // console.info('handleSubmit', resProdi);
            }

            this.setState({
                ["prodi" + pilKe]: resProdi.data.data.prodi,
                ["idProdi" + pilKe]: idProdi,
            });
        }

        this.handleOffFeching();
    };

    render() {
        return (
            <>
                <div className="row">
                    <button className="btn btn-danger pull-left" onClick={() => this.handleBack()}>
                        <ArrowBackIosOutlined fontSize="small" /> Kembali
                    </button>
                </div>
                <br></br>
                {this.loadAlert()}
                <Form onSubmit={this.handleSubmit}>
                    <br></br>
                    <Row>{this.renderSemesterParent()}</Row>

                    <br></br>
                    <Card key="pilihan" style={{ background: "" }}>
                        <Card style={{ padding: "10px", backgroundColor: "#d9edf7", color: "#31708f", borderColor: "#bce8f1" }}>Pilihan Prodi</Card>

                        <Row style={{ margin: "3px", padding: 5 }}>
                            <Col sm={3}>
                                <label>Provinsi PTN 1</label>
                                <select className="form-control" name="idProvinsi1" value={this.state.idProvinsi1} required onChange={this.handleOnchangeProvinsi}>
                                    <option value="" selected disabled>
                                        ~~ Pilih Provinsi PTN 1 ~~
                                    </option>
                                    <DropdownProvinsi provinsi={this.state.provinsi} />
                                </select>
                            </Col>
                            <Col sm={4}>
                                <label>Perguruan Tinggi 1</label>
                                <select className="form-control" name="idPtn1" value={this.state.idPtn1} required onChange={this.handleOnchangePtn}>
                                    <option value="" selected disabled>
                                        ~~ Pilih PTN 1 ~~
                                    </option>
                                    <DropdownPtn ptn={this.state.ptn1} />
                                </select>
                            </Col>
                            <Col sm={3}>
                                <label>Prodi 1</label>
                                <select className="form-control" name="idProdi1" value={this.state.idProdi1} required onChange={this.handleOnChangeProdi}>
                                    <option value="" selected disabled>
                                        ~~ Pilih Prodi 1 ~~
                                    </option>
                                    <DropdownProdi prodi={this.state.prodi1} />
                                </select>
                            </Col>
                            <Col sm={1}>
                                <label>Kuota 1</label>
                                <input class="form-control" type="number" name="kuota1" value={this.state.kuota1} onChange={this.handleOnChangeProdi} />
                            </Col>
                        </Row>
                        <hr></hr>

                        <Row style={{ margin: "3px", padding: 5, marginBottom: "1rem" }}>
                            <Col sm={3}>
                                <label>Provinsi PTN 2</label>
                                <select className="form-control" name="idProvinsi2" value={this.state.idProvinsi2} required onChange={this.handleOnchangeProvinsi}>
                                    <option value="" selected disabled>
                                        ~~ Pilih Provinsi PTN 2 ~~
                                    </option>
                                    <DropdownProvinsi provinsi={this.state.provinsi} />
                                </select>
                            </Col>
                            <Col sm={4}>
                                <label>Perguruan Tinggi 2</label>
                                <select className="form-control" name="idPtn2" value={this.state.idPtn2} required onChange={this.handleOnchangePtn}>
                                    <option value="" selected disabled>
                                        ~~ Pilih PTN 2 ~~
                                    </option>
                                    <DropdownPtn ptn={this.state.ptn2} />
                                </select>
                            </Col>
                            <Col sm={3}>
                                <label>Prodi 2</label>
                                <select className="form-control" name="idProdi2" value={this.state.idProdi2} required onChange={this.handleOnChangeProdi}>
                                    <option value="" selected disabled>
                                        ~~ Pilih Prodi 2 ~~
                                    </option>
                                    <DropdownProdi prodi={this.state.prodi2} />
                                </select>
                            </Col>
                            <Col sm={1}>
                                <label>Kuota 2</label>
                                <input class="form-control" type="number" name="kuota2" value={this.state.kuota2} onChange={this.handleOnChangeProdi} />
                            </Col>
                        </Row>
                    </Card>

                    <br></br>
                    <Card key="prestasi" style={{ background: "" }}>
                        <Card style={{ padding: "10px", backgroundColor: "#d9edf7", color: "#31708f", borderColor: "#bce8f1" }}>Data Prestasi</Card>

                        <Row style={{ margin: "3px" }}>
                            <Col sm={6}>
                                <label>Tingkatan Prestasi</label>
                                <select className="form-control" name="tingkatan" value={this.state.tingkatan} onChange={this.handleOnchangePrestasi}>
                                    <option value="" selected>
                                        ~~ Pilih Tingkatan Prestasi ~~
                                    </option>
                                    <DropdownTingkatanPrestasi tingkatan={this.state.tingkatanPrestasi} />
                                </select>
                            </Col>
                            <Col sm={6}>
                                <label>Spesifikasi Juara</label>
                                <select className="form-control" name="idSpesifikasi" value={this.state.spesifikasi} onChange={this.handleOnchangePrestasi}>
                                    <option value="" selected disabled>
                                        ~~ Spesifikasi Prestasi ~~
                                    </option>
                                    <DropdownSpesifikasiPrestasi spesifikasi={this.state.spesifikasiPrestasiFilter} />
                                </select>
                            </Col>
                        </Row>
                        <Row style={{ margin: "3px" }}>
                            <Col sm={12}>
                                <div className="form-group">
                                    <label>Keterangan</label>
                                    <input type="hidden" name="keterangan" value={this.state.keterangan} />
                                    <input class="form-control" type="text" name="keterangan" value={this.state.keterangan} onChange={this.handleOnchangePrestasi} />
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    <br></br>
                    <Card key="reg-siswa" style={{ background: "" }}>
                        <Card style={{ padding: "10px", backgroundColor: "#d9edf7", color: "#31708f", borderColor: "#bce8f1" }}>Jenis Registrasi Siswa</Card>

                        <Row style={{ margin: "3px" }}>
                            <Col sm={12}>
                                <label>Pilihan Registrasi Siswa</label>
                                <RadioGroup aria-label="regSiswa" name="regSiswa" value={this.state.regSiswa} onChange={this.handleOnChangeRegSiswa}>
                                    <FormControlLabel value="mandiri" control={<Radio />} label="Mandiri" />
                                    <FormControlLabel value="sekolah" control={<Radio />} label="Sekolah" />
                                </RadioGroup>
                            </Col>
                        </Row>
                    </Card>

                    <br></br>
                    <button type="submit" class="btn btn-primary pull-right">
                        Save
                    </button>
                </Form>
            </>
        );
    }

    // =================================== RENDER NJERO MAIN RENDER ==========================================
    renderSemesterParent() {
        if (!__.isEmpty(this.state.dataSemester)) {
            return this.state.dataSemester.map((val, i) => (
                <Col sm={4} key={i} style={{ marginBottom: "20px" }}>
                    <Card style={{ padding: "10px", backgroundColor: "#d9edf7", color: "#31708f", borderColor: "#bce8f1" }}>
                        <u>Semester {val.semester}</u>
                    </Card>
                    <Card style={{ marginBottom: "10px", padding: "10px", background: "" }}>{this.renderNilaiPersemester(val.mapel, val.semester)}</Card>
                </Col>
            ));
        } else {
            return (
                <Col sm={12}>
                    <Card style={{ padding: "10px", backgroundColor: "#f7d9d9", color: "#8f3131", borderColor: "#f1bcbc" }}>Mata Pelajaran atau Semester Belum Diinput</Card>
                </Col>
            );
        }
    }

    renderNilaiPersemester(mapel, semester) {
        return mapel.map((val, j) => {
            return (
                <Card style={{ marginBottom: "10px", padding: "10px", background: "" }} key={j}>
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td width="75%">{val.namaMapel}</td>
                                <td>
                                    <input
                                        type="number"
                                        min="0"
                                        max="100"
                                        maxLength="3"
                                        name={"#_" + val.idMapel + "_" + semester}
                                        value={this.state["#_" + val.idMapel + "_" + semester]}
                                        className="form-control"
                                        onChange={this.handleOnChangeNilai}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card>
            );
        });
    }

    handleOnChangeNilai = async (e) => {
        const splitFirst = e.target.name.split("#_", 2);
        const splitSecond = splitFirst[1].split("_", 2);

        this.setState({ [e.target.name]: e.target.value });
        this.setState({
            inputSemester: [...this.state.inputSemester, { semester: splitSecond[1], idRaport: null, idMapel: splitSecond[0], nilai: e.target.value }],
        });
    };

    handleSubmit = async (e) => {
        console.clear();
        console.log("====================================");
        console.log("tingkatan:", this.state.tingkatan);
        console.log("====================================");
        console.log("====================================");
        console.log("idSpesifikasi:", this.state.spesifikasi);
        console.log("====================================");
        e.preventDefault();
        // this.handleOnFeching();

        const formdata = new FormData(e.target);
        console.log("====================================");
        console.log(this.state.inputSemester);
        console.log("====================================");
        // array nilai ben penak le ngisi DB
        const data = {};
        const nilai = [];
        formdata.forEach(function (value, prop) {
            data[prop] = value;
            if (value == "") {
                nilai.push(prop + "_*");
            } else {
                nilai.push(prop + "_" + value);
            }
        });
        //   }

        const dataSend = {
            idSiswa: this.props.dataSiswa.idSiswa,
            kodeTahunAjaran: this.state.kodeTahunAjaran,
            idKelas: this.state.idKelas,
            nilai: this.state.inputSemester,
            pilihanProdi: [
                {
                    idProvinsi: this.state.idProvinsi1,
                    idPtn: this.state.idPtn1,
                    idProdi: this.state.idProdi1,
                    kuota: this.state.kuota1,
                },
                {
                    idProvinsi: this.state.idProvinsi2,
                    idPtn: this.state.idPtn2,
                    idProdi: this.state.idProdi2,
                    kuota: this.state.kuota2,
                },
            ],
            prestasi: [
                {
                    tingkatan: this.state.tingkatan,
                    idSpesifikasi: this.state.spesifikasi,
                    keterangan: this.state.keterangan,
                },
            ],
        };
        console.info("DATA SEK DIKIRIM", dataSend);

        // const respSubmit = await accountManagement.post(CONFIG.SNMPTN_DODATA_RAPORT_SISWA, dataSend).catch(function (error) {
        //     console.error(error);
        // });
        const respSubmit = await utilManagement.post(CONFIG_UTIL.SNBP_GET_NILAI, dataSend).catch(function (error) {});

        if (respSubmit) {
            // if (respSubmit.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
            //     this.props.fetchSiswaKelas("");
            // }

            console.log("====================================");
            console.log("Save Success => ", respSubmit);
            console.log("====================================");
            this.setState({
                alertShow: true,
                resMessage: "Berhasil Mengirim Data",
            });
            setTimeout(() => {
                this.props.handleBack();
            }, 2000);
        }
    };

    titleCard(title) {
        return (
            <Card style={{ margin: "12px", background: "aqua" }}>
                <b>{title}</b>
            </Card>
        );
    }

    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                // <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                //     <strong>{this.state.resMessage}</strong>
                // </Alert>
                <Modal size="md" aria-labelledby="contained-modal-title-vcenter" centered show={alertShow} onHide={() => this.setState({ alertShow: false })}>
                    <Modal.Body>
                        <p style={{ textAlign: "center" }}>
                            <h4>{this.state.resMessage}</h4>
                            <br /> <br />
                            <Button variant="primary" onClick={() => this.setState({ alertShow: false })}>
                                Oke
                            </Button>
                        </p>
                    </Modal.Body>
                </Modal>
            );
        }
    };
}
const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(FormMgtNilai);
